import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=f72a5022&scoped=true"
import script from "./InfoIcon.vue?vue&type=script&lang=ts"
export * from "./InfoIcon.vue?vue&type=script&lang=ts"
import style0 from "./InfoIcon.vue?vue&type=style&index=0&id=f72a5022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72a5022",
  null
  
)

export default component.exports